<template>
  <div class="dark:bg-slate-600 shadow overflow-hidden sm:rounded-md mt-3">
    <ul role="list" class="divide-y divide-gray-100 dark:divide-gray-800">
      <slot></slot>
    </ul>
  </div>
</template>
<script setup>

</script>